export default __webpack_public_path__ + "static/media/gif-1.cb89be84.gif";